import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import PublicLayout from "@/components/public/PublicLayout";

export default function PublicNotFoundPage() {
  return (
    <PublicLayout>
      <section className="public-not-found">
        <div className="public-shell">
          <p className="public-eyebrow">404</p>
          <h1>Aradığınız sayfa burada değil.</h1>
          <p>Adres değişmiş veya sayfa kaldırılmış olabilir.</p>
          <Link to="/" className="public-primary-action"><ArrowLeft size={18} />Ana sayfaya dön</Link>
        </div>
      </section>
    </PublicLayout>
  );
}
